import { render } from "./BuyGroupActions.vue?vue&type=template&id=8da7dcce"
import script from "./BuyGroupActions.vue?vue&type=script&lang=js"
export * from "./BuyGroupActions.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__